module.exports = __webpack_public_path__ + "static/img/qrafip.15a73d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrafip.jpg
// module id = mPZo
// module chunks = 0